import React from 'react';
import { ButtonToolbar } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { useFormikContext } from 'formik';
import { Button } from '..';
import Spinner from '../Spinner';

interface Props {
  onCancel: () => void;
  submitText?: string;
  isSubmitting?: boolean;
  noSpinner?: boolean;
  className?: string;
  notDisabled?: boolean;
}

const FormButtons: React.FC<Props> = ({
  onCancel,
  submitText,
  isSubmitting,
  noSpinner,
  className,
  notDisabled,
}) => {
  const { t } = useTranslation();
  const formik = useFormikContext();
  const loading = isSubmitting || formik.isSubmitting;

  return (
    <ButtonToolbar className={`modal__footer w-100 ${className}`}>
      {!noSpinner && <Spinner loading={loading} />}
      <Button
        key="btnCancel"
        className="btn-tertiary"
        onClick={onCancel}
        text={t('cancel')}
        type="button"
        disabled={loading}
      />
      <Button
        key="btnSubmit"
        className="btn-primary"
        text={submitText || t('saveChanges')}
        type="submit"
        disabled={loading || (!formik.dirty && !notDisabled)}
      />
    </ButtonToolbar>
  );
};

export default FormButtons;
